<template>
  <div class="mainContainer" v-loading="pageLoading">
    <div class="nav">
      <div class="navContainer w240">
        <p>供应商名称：</p>
        <el-input v-model="teamIpt" size="mini" class="w150" placeholder="请输入车队名称" />
      </div>
      <div class="navContainer w240">
        <p>起始区域：</p>
        <el-input v-model="startPlace" size="mini" class="w150" placeholder="请输入起始区域" />
      </div>
      <div class="navContainer w240">
        <p>交车区域：</p>
        <el-input v-model="endPlace" size="mini" class="w150" placeholder="请输入交车区域" />
      </div>
      <div class="navContainer w240">
        <p>起始港：</p>
        <el-input v-model="startPort" size="mini" class="w150" placeholder="请输入起始港" />
      </div>
      <div class="navContainer w240">
        <p>交车港：</p>
        <el-input v-model="endPort" size="mini" class="w150" placeholder="请输入交车港" />
      </div>
      <div class="navContainer w400">
        <p>装车时间：</p>
        <el-date-picker v-model="startTime" size="mini" class="w150" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期" />
        <span class="date-range">-</span>
        <el-date-picker v-model="endTime" size="mini" class="w150" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer w240">
        <p>任务状态：</p>
        <el-select v-model="state" class="w150" size="mini" filterable clearable placeholder="请选择任务状态">
          <el-option v-for="item in stateOption" :key="item.val" :label="item.name" :value="item.val"></el-option>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span @click="downLoad" class="pointer">下载模板</span>
          <span class="pointer">
            <el-upload ref="upload" class="upload-demo" :action="uploadUrl" :auto-upload="true" :show-file-list="false" :data="uploadData" :on-success="planOnSuccess" :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right ml13">批量导入</i>
            </el-upload>
          </span>
        </div>
        <car-table @btnClick="btnClick" ref="carTable" />
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <!-- 详情 -->
    <car-info ref="carInfo" @openDialgEditSupplier="openDialgEditSupplier" />
    <!-- 分配运输车 -->
    <car-driver ref="carDriver" @getList="_vehicleDeployFleetCvPageList" />
    <!-- 新增/编辑 -->
    <el-dialog v-dialog-drag="'80vh'" :title="dialogTitle" :visible.sync="dialogVisible" width="800px" center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="teamData" label-width="100px" :rules="rules" ref="ruleForm">
          <div-border label="运输起运地">
            <el-row>
              <el-col :span="14">
                <el-form-item label="起始区域：" prop="position">
                  <el-cascader :disabled="dialogTitle === '修改'" size="mini" class="w100" ref="startPosition" v-model="teamData.position" placeholder="请选择起始区域" :options="positionOption" :props="props" filterable @change="handleChange" />
                  <span v-if="teamData.position" class="position">
                    {{ teamData.type === 1 ? startAddress : teamData.position.address }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="起始港口：" prop="startPort" class="mb20">
                  <el-select :disabled="dialogTitle === '修改'" filterable v-model="teamData.startPort" size="mini" clearable placeholder="请选择起始港口" @change="portChange" value-key="id">
                    <el-option v-for="item in startPortList" :key="item.id" :label="item.supplier_name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="14">
                <el-form-item label="交车区域：" prop="carPosition" style="margin-bottom: 20px">
                  <el-cascader
                    size="mini"
                    style="width: 100%"
                    ref="endPosition"
                    v-model="teamData.carPosition"
                    placeholder="请选择交车区域"
                    :options="positionOption2"
                    :props="props"
                    filterable
                    @change="handleChange2"
                    ></el-cascader>
                  <span v-if="teamData.carPosition" style="color:#999;font-size: 12px;position:absolute;bottom:-25px;left:0;">{{teamData.carType===1?endAddress: teamData.carPosition.address}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="交车港口：" prop="endPort" style="margin-bottom: 20px">
                  <el-select v-model="teamData.endPort" filterable clearable size="mini" placeholder="请选择交车港口">
                    <el-option v-for="item in endPortList" :key="item.id" :label="item.supplier_name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
          </div-border>
          <div-border label="选择供应商">
            <div class="team mt0">
              <div class="teamItem text-right" v-for="(item, index) in teamData.team" :key="index">
                <el-row>
                  <el-form-item label="运输类型：" prop="resource" v-if="dialogTitle != '修改'">
                    <dev style="margin-right: 600px">
                      <el-radio-group v-model="resource" @change="searchCarList()">
                        <el-radio label="0">首端</el-radio>
                        <el-radio label="1">末端</el-radio>
                      </el-radio-group>
                    </dev>
                  </el-form-item>
                  <el-col :span="12" class="mb10">
                    <span class="required">供应商：</span>
                    <el-select :disabled="dialogTitle === '修改'" v-model="item.name" size="mini" filterable style="width: calc(100% - 90px)" placeholder="请选择供应商" @change="nameSelect($event, index)" value-key="id">
                      <el-option v-for="item in nameOption" :disabled="item.disabled" :key="item.id" :label="item.name" :value="item" />
                    </el-select>
                  </el-col>
                  <el-col :span="12" class="mb10">
                    <span class="required">装车时间：</span>
                    <el-date-picker v-model="item.time" style="width: calc(100% - 90px)" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择时间" />
                  </el-col>
                  <el-col :span="12" class="mb10" v-if="resource === '0'">
                    <span class="required">交车区域：</span>
                    <el-cascader size="mini" style="width: calc(100% - 90px)" v-model="item.endPosition" placeholder="请选择交车区域" :options="positionOption2" :props="props" ref="endPosition" filterable @change="handleChange2($event, index)" />
                  </el-col>
                  <el-col :span="12" class="mb10" v-if="resource === '0'">
                    <span>交车港口：</span>
                    <el-select v-model="item.endPort" style="width: calc(100% - 90px)" filterable clearable size="mini" value-key="id" placeholder="请选择交车港口">
                      <el-option v-for="item in endPortList[index]" :key="item.id" :label="item.supplier_name" :value="item"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12" class="mb10">
                    <span class="required">交车时间：</span>
                    <el-date-picker v-model="item.estimateArriveTime" style="width: calc(100% - 90px)" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择时间" />
                  </el-col>
                  <el-col :span="12">
                    <span class="required">装车数量：</span>
                    <el-input v-model="item.num" size="mini" style="width: calc(100% - 90px)" placeholder="请输入数量" />
                  </el-col>
                  <el-col v-if="dialogTitle === '新增'" :span="12" class="del-style">
                    <el-radio v-model="teamData.radio" :label="index"></el-radio>
                    <i v-show="teamData.team.length > 1" class="el-icon-error pointer" @click="teamRemove(index)" />
                  </el-col>
                </el-row>
              </div>
              <div v-if="dialogTitle === '新增' && resource === '0'" class="teamAdd">
                <span>添加供应商：</span>
                <div class="add" @click="addTeam">+</div>
              </div>
            </div>
          </div-border>
          <div-border :label="activeName">
            <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="委托车" name="委托车">
                <!-- 委托车 -->
                <div class="productTable mt10 mb20">
                  <div class="nav mb10">
                    <div class="navContainer w200">
                      <p>批次号：</p>
                      <el-input v-model="entrust.batch" size="mini" class="w140" placeholder="请输入批次号" />
                    </div>
                    <div class="navContainer w200">
                      <p>运单号：</p>
                      <el-input v-model="entrust.waybill" size="mini" class="w140" placeholder="请输入运单号" />
                    </div>
                    <div class="navContainer w200">
                      <p>车架号：</p>
                      <el-input
                        v-model="entrust.frame"
                        size="mini"
                        class="w140"
                        placeholder="请输入车架号"
                        @paste.native.capture.prevent="
                          value => {
                            return searchCopyFormat(value, 'entrust.frame');
                          }
                        " />
                    </div>
                    <div class="navContainer w200">
                      <p>品牌：</p>
                      <el-input v-model="entrust.brandName" size="mini" class="w140" placeholder="请输入品牌" />
                    </div>
                    <div class="navContainer w200">
                      <p>型号：</p>
                      <el-input v-model="entrust.modelName" size="mini" class="w140" placeholder="请输入型号" />
                    </div>
                    <div class="navContainer w200">
                      <p>到达港：</p>
                      <el-input v-model="entrust.arrivePort" size="mini" class="w140" placeholder="请输入到达港" />
                    </div>
                    <div class="navContainer w300">
                      <p>交车区域：</p>
                      <el-cascader
                        size="mini"
                        class="w240"
                        @change="triggerQuery(entrust.arrivePlaceId)"
                        v-model="entrust.arrivePlaceId"
                        placeholder="请选择交车区域"
                        :options="positionOption"
                        :props="{
                          value: 'id',
                          label: 'cityName',
                          children: 'children',
                          checkStrictly: true,
                          multiple: true,
                        }"
                        collapse-tags
                        :show-all-levels="false"
                        filterable />
                    </div>
                    <div class="navBtn">
                      <el-button size="mini" class="searchBtn" @click="searchCarList">查询 </el-button>
                      <el-button size="mini" class="resetBtn" @click="resetBtnVehicle">重置 </el-button>
                    </div>
                    <span style="margin-left: 10px">已勾选:{{ selectDataAdd.length }}</span>
                  </div>
                  <el-table v-loading="carLoad" :data="addCarTable" class="w100" row-key="id" border :reserve-selection="true" :header-cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '35px' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }" tooltip-effect="dark" ref="carTableRef" @selection-change="selectChange">
                    <el-table-column type="selection" :reserve-selection="true" width="30" align="center"></el-table-column>
                    <el-table-column label="分配供应商" prop="assignName" align="center" />
                    <el-table-column label="批次号" prop="batchNumber" align="center" />
                    <el-table-column label="运单号" prop="waybillNo" align="center" />
                    <el-table-column label="车架号" width="150" prop="frameNumber" align="center" />
                    <el-table-column label="品牌" prop="brandName" align="center" />
                    <el-table-column label="型号" prop="modelName" align="center" />
                    <el-table-column label="起运地" width="150" prop="departurePlace" align="center" />
                    <el-table-column label="交车地" width="150" prop="arrivePlace" align="center" />
                  </el-table>
                  <div class="paginationContainer mt10">
                    <span>共{{ carPage.total }}条</span>
                    <el-pagination background small :page-sizes="[50, 80, 110, 140]" layout="sizes,prev, pager, next,jumper" :total="carPage.total" :current-page.sync="carPage.page" @size-change="carTableSizeChange" @current-change="carTableChange" @prev-click="carTableChange" @next-click="carTableChange" />
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="首端" name="首端">
                <!-- 首端 -->
                <div class="productTable mt10 mb20">
                  <div class="nav mb10">
                    <div class="navContainer w200">
                      <p>装车港口：</p>
                      <el-input v-model="startData.port" size="mini" class="w140" placeholder="请输入装车港口" />
                    </div>
                    <div class="navBtn">
                      <el-button size="mini" class="searchBtn" @click="searchStartList">查询 </el-button>
                    </div>
                  </div>
                  <el-table v-loading="carLoad" :data="startTable" class="w100" key="startTable" border :header-cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '35px' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }" tooltip-effect="dark">
                    <el-table-column type="index" label="序号" align="center" />
                    <el-table-column label="起运区域" prop="departurePlace" align="center" />
                    <el-table-column label="装船港口" prop="departurePort" align="center" />
                    <el-table-column label="装船区域" prop="departurePortArea" align="center" />
                    <el-table-column label="可分配数量" prop="countNum" align="center" />
                  </el-table>
                  <div class="paginationContainer mt10">
                    <span>共{{ startData.total }}条</span>
                    <el-pagination background small :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="startData.total" :current-page.sync="startData.page" @size-change="startTableSizeChange" @current-change="startTableChange" @prev-click="startTableChange" @next-click="startTableChange" />
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="末端" name="末端">
                <!-- 末端 -->
                <div class="productTable mt10 mb20">
                  <div class="nav mb10">
                    <div class="navContainer w200">
                      <p>交车区域：</p>
                      <el-cascader size="mini" class="w140" v-model="endData.delivery" placeholder="请选择交车区域" :options="positionOption2" :props="props" filterable clearable />
                    </div>
                    <div class="navContainer w200">
                      <p>品牌：</p>
                      <el-input v-model="endData.brandName" size="mini" class="w140" placeholder="请输入品牌" />
                    </div>
                    <div class="navBtn">
                      <el-button size="mini" class="searchBtn" @click="searchEnd">查询</el-button>
                      <el-button size="mini" type="primary" @click="exportClick">导出</el-button>
                    </div>
                  </div>
                  <el-table v-loading="carLoad" :data="endTable" class="w100" key="endTable" row-key="soleId" border :reserve-selection="true" :header-cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '35px' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }" tooltip-effect="dark" :expand-row-keys="expands" @expand-change="expandColumn">
                    <el-table-column type="expand">
                      <template slot-scope="props">
                        <el-table
                          v-loading="expandsLoad"
                          :data="expandsData"
                          class="w100"
                          key="endTable"
                          border
                          :reserve-selection="true"
                          :header-cell-style="{
                            color: '#7F7F7F',
                            'font-size': '13px',
                            height: '35px',
                          }"
                          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }"
                          tooltip-effect="dark">
                          <el-table-column label="批次号" prop="batchNumber" align="center" />
                          <el-table-column label="运单号" prop="waybillNo" align="center" />
                          <el-table-column label="车架号" prop="frameNumber" align="center" />
                          <el-table-column label="品牌" prop="brandName" align="center" />
                          <el-table-column label="型号" prop="modelName" align="center" />
                        </el-table>
                      </template>
                    </el-table-column>
                    <el-table-column type="index" label="序号" align="center" />
                    <el-table-column label="起始港" prop="arrivePort" align="center" />
                    <el-table-column label="起始区域" prop="arrivePortArea" align="center" />
                    <el-table-column label="交车区域" prop="arrivePlace" align="center" />
                    <el-table-column label="品牌名称" prop="brandName" align="center" />
                    <el-table-column label="可分配数量" prop="countNum" align="center" />
                  </el-table>
                  <div class="paginationContainer mt10">
                    <span>共{{ endData.total }}条</span>
                    <el-pagination background small :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="endData.total" :current-page.sync="endData.page" @size-change="endTableSizeChange" @current-change="endTableChange" @prev-click="endTableChange" @next-click="endTableChange" />
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div-border>
          <div class="btnContainer">
            <el-button class="searchBtn" :loading="loading" @click="addClick" size="small">确定 </el-button>
            <el-button class="resetBtn" @click="dialogClose" size="small">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 完成时间 -->
    <car-finish ref="carFinish" @getList="_vehicleDeployFleetCvPageList" />
    <!-- 修改交车地 -->
    <car-delivery ref="carDelivery" @getList="_vehicleDeployFleetCvPageList" />
    <!-- 修改供应商 -->
    <el-dialog title="修改供应商" :visible.sync="supplierVisible" @close="supplierClose" center width="500px">
      <div v-loading="supplierLoading" class="p30 pb0">
        <el-form :model="supplierData" label-width="100px" :rules="supplierRules" ref="supplierForm">
          <el-form-item label="供应商：" prop="port">
            <el-select v-model="supplierData.supplierId" class="w300" @change="handleChangeSupplierId" filterable clearable size="mini" value-key="id" placeholder="请选择供应商">
              <el-option v-for="item in nameOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="supplierCloseDialog">取 消</el-button>
        <el-button size="mini" :loading="supplierSureLoad" type="primary" @click="supplierFinish" v-if="supplierType == 1">确 定</el-button>
        <el-button size="mini" :loading="supplierSureLoad" type="primary" @click="supplierFinishi" v-if="supplierType == 2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import { vehicleDeployInfoCvAdd, vehiclGetChildByPosition, getHighwayParam, vehicleDeployInfoDelete, vehicleDeployInfoFinish, vehicleDeployInfoUpdate, vehiclePublicSelectWarehouse, supplierPublicSelectPort, getSelectPort, supplierPublicSelectDistributor, vehicleDeployFleetCvDetail, vehicleDetailPageList, vehicleDeployFleetCvPageList, vehicleDeployInfoCvAddTransportVehicle, vehicleDeploygetDistributionByCar, startFringeList, endFringeList, changeDelivery, endListDetails, updateSupplier, updateSupplierByCarIds } from '@/service/vehiclelog';
  import { baseUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';
  import { formatDateTime } from '@/config/mUtils';
  import { getImport, getImportUrl } from '@/service/getIP';
  import CarTable from '@/views/vehiclelog/planManage/components/car-components/carTable';
  import CarInfo from '@/views/vehiclelog/planManage/components/car-components/carInfo';
  import CarDriver from '@/views/vehiclelog/planManage/components/car-components/carDriver';
  import CarFinish from '@/views/vehiclelog/planManage/components/car-components/carFinish';
  import CarDelivery from '@/views/vehiclelog/planManage/components/car-components/carDelivery';
  import { applicationAreaInfo } from '@/service/getData';

  export default {
    components: {
      CarDelivery,
      CarFinish,
      CarDriver,
      CarInfo,
      CarTable,
      divBorder,
    },
    data() {
      return {
        activeIds: '',
        supplierType: 1,
        supplierVisible: false,
        supplierLoading: false,
        supplierSureLoad: false,
        activeId: '',
        supplierData: {
          supplierId: '',
        },
        supplierRules: {},
        resource: '0',
        options: [
          {
            value: '0',
            lable: '否',
          },
          {
            value: '1',
            lable: '是',
          },
        ],
        optionsState: [
          {
            value: '0',
            lable: '待装车',
          },
          {
            value: '1',
            lable: '已装船',
          },
          {
            value: '2',
            lable: '已交车',
          },
          {
            value: '-1',
            lable: '已取消',
          },
        ],
        carList: {
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          shipCabinName: '',
          startPortName: '',
          deliveryPortName: '',
          isMassLoss: '',
          state: '',
        },
        uploadUrl: '', //导入地址
        uploadData: {
          file: '',
        },
        taskIpt: '',
        teamIpt: '',
        startPlace: '', // 起始区域
        endPlace: '', // 交车区域
        startPort: '', // 起始港
        endPort: '', // 交车港
        startTime: '',
        endTime: '',
        state: '',
        stateOption: [
          {
            name: '全部',
            val: '',
          },
          {
            name: '待开始',
            val: '0',
          },
          {
            name: '执行中',
            val: '1',
          },
          {
            name: '已完成',
            val: '2',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        driverData: [], // 托运车信息
        carData: [], // 委托车信息
        driverDialogVisible: false, // 分配运输车显隐
        // 详情
        detailDialogVisible: false,
        detailData: {},
        detail: {
          page: 1,
          total: 0,
          size: 10,
        },
        operationData: [],
        // 新增/修改
        dialogTitle: '',
        dialogVisible: false,
        startPortList: [], // 起始港口
        endPortList: [], // 交车港口
        // 修改交车地
        deliveryVisible: false,
        deliveryData: {},
        deliveryRules: {
          delivery: {
            required: true,
            message: '请选择交车地',
            trigger: 'blur',
          },
        },

        // 委托车
        addCarTable: [],
        addCarTableAll: [], // 委托车所有数据
        checkCar: [], // 修改时委托车已存在数据
        carLoad: false, // 委托车表格加载状态
        carPage: {
          size: 50,
          page: 1,
          total: 0,
        }, // 选择委托车分页数据
        // 首端
        startData: {
          port: '',
          size: 10,
          page: 1,
          total: 0,
        }, // 首端分页数据
        startTable: [], // 首端表格数据
        // 末端
        endData: {
          delivery: '',
          brandName: '',
          size: 10,
          page: 1,
          total: 0,
        }, // 末端分页数据
        endTable: [], // 末端表格数据

        startAddress: '', //委托商 起始详细地址
        endAddress: '', //委托商 目的详细地址
        selectDataAdd: [],
        addDriverTable: [],
        loading: false,
        restaurants: [],
        nameOption: [],
        teamData: {
          position: '',
          startPort: '',
          radio: 0,
          team: [
            {
              name: '',
              num: '',
              time: '',
              estimateArriveTime: '',
              endPosition: '',
              endPort: '',
              type: '',
            },
          ],
        },
        rules: {
          plan: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          team: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          car: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          type: [
            {
              required: true,
              message: `请选择`,
              trigger: 'change',
            },
          ],
          position: [
            {
              required: true,
              message: '请选择起始位置',
              trigger: 'change',
            },
          ],
          carType: [
            {
              required: true,
              message: '请选择交车类型',
              trigger: 'change',
            },
          ],
          carPosition: [
            {
              required: true,
              message: '请选择交车位置',
              trigger: 'change',
            },
          ],
          time: [
            {
              required: true,
              message: '请选择装车时间',
              trigger: 'change',
            },
          ],
          estimateArriveTime: [
            {
              required: true,
              message: '请选择交车时间',
              trigger: 'change',
            },
          ],
          startPort: [
            {
              required: false,
              message: '请选择起始港口',
              trigger: 'change',
            },
          ],
          endPort: [
            {
              required: false,
              message: '请选择交车港口',
              trigger: 'change',
            },
          ],
        },
        props: {
          value: 'id',
          label: 'cityName',
          children: 'children',
        },
        consignorMap: new Map(),
        positionOption: [],
        positionOption2: [],
        tempOption: [],
        // 委托车查询条件
        entrust: {
          batch: '', // 批次号
          waybill: '', // 运单号
          frame: '', // 车架号
          brandName: '',
          modelName: '',
          arrivePort: '',
          arrivePlaceId: '',
        },
        selectAllHint: false, // 全选提示
        distriRules: {
          license: [
            {
              required: true,
              message: '请输入车牌号',
              trigger: 'blur',
            },
          ],
          vehicleType: [
            {
              required: true,
              message: '请选择车辆类型',
              trigger: 'blur',
            },
          ],
          fleet: [
            {
              required: true,
              message: '请选择车队',
              trigger: 'blur',
            },
          ],
          vehicleStatus: [
            {
              required: true,
              message: '请选择车辆状态',
              trigger: 'blur',
            },
          ],
          driverName: [
            {
              required: true,
              message: '请输入司机姓名',
              trigger: 'blur',
            },
          ],
          driverTelephone: [
            {
              required: true,
              message: '请输入司机电话',
              trigger: 'blur',
            },
          ],
        },
        // 分配运输车数据
        distriForm: {
          fleet: '',
          vehicleData: [
            {
              truckName: '',
              vehicleType: '',
              vehicleStatus: '',
              driverName: '',
              driverTelephone: '',
            },
          ],
        },
        addLoad: false,
        activeName: '委托车', // 标签页
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        dialogState: 'max',
        pageLoading: false,
        expands: [],
        expandsData: [],
        expandsLoad: false,
      };
    },
    created() {
      // this.tempOption = JSON.parse(sessionStorage.getItem('areaList'));
      // if (this.tempOption === null || this.tempOption.length === 0) this.getAreaList();
      this.getAreaList();
    },
    computed: {
      getTimeOne() {
        return function (time, type) {
          if (type != 0 && type != undefined) {
            return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
          } else {
            return null;
          }
        };
      },
      getTime() {
        return function (time, type) {
          if (type == 2 || (time != null && time != undefined && type == undefined)) {
            return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
          } else {
            return null;
          }
        };
      },
      getCarState() {
        return function (value) {
          if (value > 0) {
            return '已分配';
          } else {
            return '未分配';
          }
        };
      },
      getCarState2() {
        return function (state) {
          switch (state) {
            case 0:
              return ':待开始';
            case 1:
              return '运输中';
            case 2:
              return '已交车';
            case 5:
              return '装车中';
          }
        };
      },
      getCarState1() {
        return function (state) {
          switch (state) {
            case 0:
              return '待装车';
            case 1:
              return '已装车';
            case 2:
              return '已交车';
            case -1:
              return '已取消';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待开始';
            case 1:
              return '执行中';
            case 2:
              return '已完成';
          }
        };
      },
    },
    filters: {
      statusFormat(value) {
        switch (value) {
          case 0:
            return '待运输';
          case 1:
            return '运输中';
          case 2:
            return '已完成';
        }
      },
    },
    mounted() {
      // this.init();
      this.uploadUrl = getImportUrl('/deployFleet/batchImportDeploy'); //导入接口
    },
    methods: {
      openDialgEditSupplier(ids) {
        console.log(ids);
        this.activeIds = ids;
        (this.supplierType = 2), this._getHighwayParam();
        this.supplierVisible = true;
      },
      handleChangeSupplierId() {},
      supplierClose() {
        this.supplierType = 1;
        this.supplierData.supplierId = '';
      },
      supplierCloseDialog() {
        this.supplierVisible = false;
      },
      async supplierFinish() {
        this.supplierSureLoad = true;
        const res = await updateSupplier({
          id: this.activeId,
          supplierId: this.supplierData.supplierId,
        });
        // console.log(res);
        if (res.status != 0) {
          this.$message.error(res.message);
        } else {
          this.$message({
            message: res.message,
            type: 'success',
          });
          this.supplierVisible = false;
          this.searchBtn();
        }
        this.supplierSureLoad = false;
      },
      async supplierFinishi() {
        // console.log(this.activeIds);
        // console.log(this.supplierData.supplierId);
        this.supplierSureLoad = true;
        const res = await updateSupplierByCarIds({ ids: this.activeIds, supplierId: this.supplierData.supplierId });
        if (res.status != 0) {
          this.$message.error(res.message);
        } else {
          this.$message({
            message: res.message,
            type: 'success',
          });
          this.$nextTick(() => {
            this.$refs.carInfo.showData();
          });

          // this.$carInfo.carPageList();
          this.supplierVisible = false;
          // this.searchBtn();
          // this._getHighwayParam();
        }
        this.supplierSureLoad = false;
      },
      async getAreaList() {
        this.pageLoading = true;
        const { status, message, data } = await applicationAreaInfo();
        this.pageLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tempOption = data;
        // console.log(this.tempOption);
      },
      async carpageList() {
        //委托车信息查询
        let data = {
          basicId: this.detail.id,
          batchNumber: this.carList.batchNumber,
          waybillNo: this.carList.waybillNo,
          frameNumber: this.carList.frameNumber,
          brand: this.carList.brand,
          shipCabinName: this.carList.shipCabinName,
          startPortName: this.carList.startPortName,
          deliveryPortName: this.carList.deliveryPortName,
          isMassLoss: this.carList.isMassLoss,
          state: this.carList.state,
        };
        const res = await vehicleDetailPageList(data);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detail.total = res.data.total;
        this.carData = res.data.records;
      },
      //导出
      exportClick() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/transportChild/backEndExport?delivery=${this.endData.delivery}&brandName=${this.endData.brandName}&regionId=${this.teamData.position ? this.teamData.position[this.teamData.position.length - 1] : ''}&portId=${this.teamData.startPort || ''}&access_token=${token}`;
      },
      resetCar() {
        this.carList = {
          basicId: '',
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          shipCabinName: '',
          startPortName: '',
          deliveryPortName: '',
          isMassLoss: '',
          state: '',
        };
      },
      // 下载模板
      downLoad() {
        window.location.href = '/file/公路调配批量导入.xlsx';
      },
      /**
       * 导入成功
       * @param data 分页更新数据
       */
      // 批量导入
      planOnSuccess(res) {
        this.pageLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            await this._vehicleDeployFleetCvPageList();
          },
        });
        // this.TableDatas = res.data
        // this._vehicleDeployFleetCvPageList();
      },
      beforeUpload(file) {
        let len = file.name.split('.').length;
        if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
          this.uploadData.file = file.name;
          this.pageLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      async init() {
        await this._vehicleDeployFleetCvPageList();
      },
      // 单元格样式
      cellStyle(row) {
        if (row.row.startType == 1 && row.column.label == '装车地') {
          return {
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
            'padding-right': '30px !important',
          };
        } else if (row.row.deliveryType == 1 && row.column.label == '交车地') {
          return {
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
            'padding-right': '30px !important',
          };
        } else {
          return {
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
          };
        }
      },
      async _getHighwayParam() {
        const res = await getHighwayParam();
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.nameOption = res.data;
        }
      },
      // 分页查询
      async _vehicleDeployFleetCvPageList() {
        const obj = {
          fleetName: this.teamIpt,
          taskCode: this.taskIpt,
          startTime: this.startTime,
          endTime: this.endTime,
          startName: this.startPlace,
          deliveryName: this.endPlace,
          startPortName: this.startPort,
          deliveryPortName: this.endPort,
          status: this.state,
          // startTime:this.timeIpt[0]?this.timeIpt[0]:'',
          // endTime:this.timeIpt[1]?this.timeIpt[1]:'',
          rows: this.size,
          page: this.page,
        };
        this.$refs.carTable.tableLoad = true;
        const res = await vehicleDeployFleetCvPageList(obj);
        this.$refs.carTable.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$refs.carTable.tableData = res.data.records;
        // this.TableDatas = res.data.records
        this.total = res.data.total;
      },
      // 结束时间
      dateChange(val) {
        if (this.endTime && this.startTime && this.endTime <= this.startTime) {
          if (val == this.endTime) this.endTime = '';
          if (val == this.startTime) this.startTime = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 委托商下拉
      async _vehiclePublicSelectWarehouse() {
        let res = await vehiclePublicSelectWarehouse();
        if (res.status !== 0) return this.$message.error(res.message);
        let data = res.data;
        res.data.forEach((item, index) => {
          data[index].warehouseList = item.warehouseList.map(item => {
            this.consignorMap.set(item.id, item);
            return {
              id: item.id,
              customerName: item.addr,
            };
          });
        });
        return data;
      },
      // 港口
      async _supplierPublicSelectPort() {
        let portRes = await supplierPublicSelectPort();
        if (portRes.status !== 0) return this.$message.error(portRes.message);
        return portRes.data;
      },
      // 经销商
      async _supplierPublicSelectDistributor() {
        const res = await supplierPublicSelectDistributor();
        if (res.status !== 0) return this.$message.error(res.message);
        return res.data;
      },
      // 根据区域获取港口
      async _getSelectPort(id, type, index) {
        let port = await getSelectPort(id);
        if (port.status !== 0) return this.$message.error(port.message);
        if (type == 1) {
          this.startPortList = port.data;
        } else {
          this.endPortList[index] = port.data;
          console.log(this.endPortList);
        }
        this.$forceUpdate();
      },
      async getEndPort(id) {
        let port = await getSelectPort(id);
        if (port.status !== 0) return this.$message.error(port.message);
        this.endPortList[0] = port.data;
        this.$forceUpdate();
      },
      /***************
       * 选择供应商
       */
      // 删除车队
      teamRemove(index) {
        this.nameOption.forEach(item => {
          if (item.id === this.teamData.team[index].name.id) item.disabled = false;
        });
        let temp = '';
        if (this.teamData.team[index].table && this.teamData.team[index].table.length > 0) {
          temp = this.teamData.team[index].table[0].assignName;
        }
        if (this.addCarTableAll && this.addCarTableAll.length > 0) {
          this.addCarTableAll.forEach(item => {
            if (temp != '' && item.assignName == temp) {
              this.$refs.carTableRef.toggleRowSelection(item, false);
              item.assignName = '';
            }
          });
        }
        if (this.teamData.team.length && this.teamData.team.length > 1) this.teamData.team.splice(index, 1);
      },
      // 添加车队
      addTeam() {
        let temp = false;
        if (this.teamData.team && this.teamData.team.length > 0) {
          this.teamData.team.forEach(item => {
            for (let teamKey in item) {
              if (teamKey == 'table' || teamKey == 'endPort') continue;
              if (!item[teamKey] || item[teamKey] == '') {
                temp = true;
              }
            }
          });
        }
        if (temp) {
          return this.$message.warning('选择供应商数据必填项数据不能为空！');
        }
        this.teamData.team.push({
          name: '',
          num: 1,
          time: '',
          estimateArriveTime: '',
          endPosition: '',
          endPort: '',
          table: [],
        });
      },
      // 供应商改变
      nameSelect(val, index) {
        let temp = '';
        if (this.teamData.team[index].table && this.teamData.team[index].table.length > 0) {
          temp = this.teamData.team[index].table[0].assignName;
        }
        if (this.addCarTableAll && this.addCarTableAll.length > 0) {
          this.addCarTableAll.forEach(item => {
            if (temp != '' && item.assignName == temp) {
              item.assignName = val.name;
            }
          });
        }
        this.$forceUpdate();
      },
      // 起始区域改变
      async handleChange(value) {
        this.teamData.startPort = '';
        this._getSelectPort(value[value.length - 1], 1);
        if (this.teamData.type == 1) {
          this.startAddress = this.consignorMap.get(value[1]).addr;
        }
        this.consignorMap.get();
        if (this.activeName == '首端') {
          this.searchStart();
        }
        if (this.activeName == '末端') {
          this.searchEnd();
        }
        if (this.activeName == '委托车') {
          this.searchCar();
        }
      },
      // 起始港口改变
      async portChange() {
        // this.searchCar();
        if (this.activeName == '首端') {
          this.searchStart();
        }
        if (this.activeName == '末端') {
          this.searchEnd();
        }
        if (this.activeName == '委托车') {
          this.searchCar();
        }
      },
      // 交车区域改变
      handleChange2(value, index) {
        console.log(this.teamData.team);
        if (value) {
          this._getSelectPort(value[value.length - 1], 2, index);
        }
        if (this.teamData.team && index) {
          for (let i = 0; i < this.teamData.team.length - 1; i++) {
            for (let j = i + 1; j < this.teamData.team.length; j++) {
              if (this.teamData.team[i].name.id === this.teamData.team[j].name.id && this.teamData.team[i].endPosition[this.teamData.team[i].endPosition.length - 1] === this.teamData.team[j].endPosition[this.teamData.team[j].endPosition.length - 1]) {
                this.teamData.team[j].endPosition = [];
                this.teamData.team[this.teamData.radio].endPort = '';
                this.deliveryData.port = '';
                return this.$message.warning('相同供应商不能选择相同交车区域！');
              }
            }
          }
        }
      },

      // 每页数据条数改变
      contractSizeChange(sizes) {
        this.size = sizes;
        this._vehicleDeployFleetCvPageList();
      },
      // 当前页改变
      contractCurrentChange(page) {
        this.page = page;
        this._vehicleDeployFleetCvPageList();
      },

      /**
       * 委托车、首端、末端 切换
       */
      // 标签切换
      handleClick() {
        if (this.activeName == '首端') {
          this.searchStart();
        }
        if (this.activeName == '末端') {
          this.searchEnd();
        }
        if (this.activeName == '委托车') {
          this.searchCar();
        }
      },
      // 委托车 -- 每页数据条数改变
      carTableSizeChange(size) {
        // 每页条数
        this.carPage.size = size;
        this.searchCar();
      },
      // 委托车 -- 当前页改变
      carTableChange(page) {
        // 翻页
        this.carPage.page = page;
        this.searchCar();
      },
      // 委托车 -- 查询
      searchCarList() {
        console.log(this.entrust.arrivePlaceId);
        this.carPage.page = 1;
        this.searchCar();
      },
      // 委托车 -- 分页查询
      async searchCar() {
        let arrivePlaceId = [];
        if (this.entrust.arrivePlaceId != '' && this.entrust.arrivePlaceId != undefined && this.entrust.arrivePlaceId != null) {
          arrivePlaceId = this.entrust.arrivePlaceId.map(item => item.join(','));
        }
        let arriveId = '';
        arrivePlaceId.forEach(c => {
          if (arriveId.length === 0) {
            arriveId = c + '/';
          } else {
            arriveId += c + '/';
          }
        });
        let obj = {
          //   departurePlaceId: this.teamData.position[this.teamData.position.length - 1],  // 起始地id
          departurePortId: this.teamData.startPort, // 起始港口id
          departurePlaceId: this.teamData.position[this.teamData.position.length - 1], //起始区域
          batchNumber: this.entrust.batch, // 批次号
          waybillNo: this.entrust.waybill, // 运单编号
          frameNumber: this.entrust.frame, // 车架号
          brandName: this.entrust.brandName,
          modelName: this.entrust.modelName,
          arrivePort: this.entrust.arrivePort,
          arrivePlaceId: arriveId,
          resource: this.resource,
          page: this.carPage.page,
          rows: this.carPage.size,
          pageType: 2,
        };
        if (this.dialogTitle == '修改') {
          obj.deployId = this.teamData.id;
        }
        this.carLoad = true;
        const res = await vehiclGetChildByPosition(obj);
        if (res.status !== 0) {
          this.carLoad = false;
          return this.$message.error(res.message);
        }
        this.addCarTable = res.data.records;
        this.carPage.total = res.data.total;
        this.$forceUpdate();
        this.$nextTick(() => {
          //选择委托车 选项回显
          if (this.teamData.team && this.teamData.team.length > 0) {
            this.teamData.team.forEach(team => {
              if (team.table && team.table.length > 0 && this.addCarTable && this.addCarTable.length > 0) {
                team.table.forEach(item => {
                  this.addCarTable.forEach(row => {
                    if (row.id == item.id) {
                      row.assignName = team.name.name;
                      item.assignName = team.name.name;
                      this.$refs.carTableRef.toggleRowSelection(row, true);
                      this.$forceUpdate();
                    }
                  });
                });
              }
            });
          }
        });
        this.carLoad = false;
      },
      // 委托车 -- 选中数据改变
      selectChange(value) {
        // 提示供应商必填
        let temp = this.teamData.team[this.teamData.radio] ? this.teamData.team[this.teamData.radio].name : '';
        if (value.length > 0) {
          if (!temp || temp == '') {
            value.forEach(item => {
              this.$refs.carTableRef.toggleRowSelection(item, false);
            });
            return (this.selectAllHint = true);
          } else {
            this.selectAllHint = false;
          }
        }
        // 将取消选中的数据的分配供应商清空
        for (let i = 0; i < this.selectDataAdd.length; i++) {
          let obj = this.selectDataAdd[i];
          let num = obj.id;
          let isExist = false;
          for (let j = 0; j < value.length; j++) {
            let aj = value[j];
            let n = aj.id;
            if (n == num) {
              isExist = true;
              break;
            }
          }
          if (!isExist) {
            obj.assignName = '';
          }
        }
        // 给选中数据的分配供应商赋值
        if (!this.selectAllHint && value.length > 0) {
          for (let i = 0; i < value.length; i++) {
            if (!value[i].assignName || value[i].assignName == '') {
              value[i].assignName = temp.name;
            }
          }
        }
        // 选中的委托车
        if (value.length > 0 && this.teamData.team.length > 0) {
          this.teamData.team.forEach((team, index) => {
            this.teamData.team[index].table = [];
            value.forEach(item => {
              if (item.assignName == this.teamData.team[index].name.name) {
                this.teamData.team[index].table.push(item);
              }
            });
          });
          this.$forceUpdate();
        }
        this.selectDataAdd = value;
      },
      // 首端 -- 查询
      searchStartList() {
        this.startData.page = 1;
        this.searchStart();
      },
      // 首端 -- 分页查询
      async searchStart() {
        let obj = {
          regionId: this.teamData.position ? this.teamData.position[this.teamData.position.length - 1] : '', // 起始地id
          portId: this.teamData.startPort || '', // 起始港口id
          departurePort: this.startData.port || '', // 装车港口
          page: this.startData.page,
          rows: this.startData.size,
        };
        this.carLoad = true;
        const res = await startFringeList(obj);
        this.carLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.startTable = res.data.records;
        this.startData.total = res.data.total;
      },
      // 首端 -- 每页数据量改变
      startTableSizeChange(size) {
        this.startData.size = size;
        this.searchStart();
      },
      // 首端 -- 当前页改变
      startTableChange(page) {
        this.startData.page = page;
        this.searchStart();
      },
      // 末端 -- 分页查询
      async searchEnd() {
        let obj = {
          regionId: this.teamData.position ? this.teamData.position[this.teamData.position.length - 1] : '', // 起始地id
          portId: this.teamData.startPort || '', // 起始港口id
          arrivePlaceId: this.endData.delivery && this.endData.delivery.length > 0 ? this.endData.delivery[this.endData.delivery.length - 1] : '', // 车架号
          page: this.endData.page,
          rows: this.endData.size,
          brandName: this.endData.brandName,
        };
        this.carLoad = true;
        const res = await endFringeList(obj);
        this.carLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.endTable = res.data.records;
        this.endData.total = res.data.total;
      },
      // 末端 -- 每页数据量改变
      endTableSizeChange(size) {
        this.endData.size = size;
        this.searchEnd();
      },
      // 末端 -- 当前页改变
      endTableChange(page) {
        this.endData.page = page;
        this.searchEnd();
      },
      // 详情
      async detailClick(id) {
        await this.$refs.carInfo.openDialog(id);
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确定要删除当前车辆吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await vehicleDeployInfoDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._vehicleDeployFleetCvPageList();
          })
          .catch(() => {});
      },
      // 修改
      async changeClick(id) {
        // 起始区域，目的区域
        this._getHighwayParam();
        this.startTable = [];
        this.endTable = [];
        this.activeName = '委托车';
        this.positionOption = this.tempOption;
        this.positionOption2 = this.tempOption;
        this.carPage.page = 1;
        this.dialogTitle = '修改';
        const res = await vehicleDeployFleetCvDetail(id);
        if (res.status != 0) return this.$message.error(res.message);
        let { startPortId, startFullId, startId, fleetId, fleetName, entruckTime, estimateArriveTime, deliveryFullId, deliveryId, deliveryPortName, deliveryPortId, fleetCount, carList } = res.data;
        if (carList != null) {
          this.selectDataAdd = carList;
        }
        // 起始区域改变
        if (startId) {
          this._getSelectPort(startId, 1);
        }
        // 交车区域改变
        if (deliveryId) {
          this.getEndPort(deliveryId);
        }
        // 选择供应商
        let list = [];
        if (carList && carList.length > 0) {
          carList.forEach(item => {
            list.push({
              ...item,
              assignName: item.supplierName,
              batchNumber: item.batchNumber,
              waybillNo: item.waybillNo,
              frameNumber: item.frameNumber,
              brandName: item.brand,
              modelName: item.model,
              departurePlace: item.startName,
              arrivePlace: item.deliveryName,
              ids: item.id,
              id: item.carId,
            });
          });
        }
        if (startFullId.indexOf(',') != -1) {
          startFullId = startFullId.split(',');
        } else {
          startFullId = startFullId.split('/');
        }
        if (deliveryFullId.indexOf(',') != -1) {
          deliveryFullId = deliveryFullId.split(',');
        } else {
          deliveryFullId = deliveryFullId.split('/');
        }
        this.teamData = {
          id: res.data.id,
          position: startFullId || [],
          startPort: startPortId || '',
          radio: 0,
          status: res.data.status,
          team: [
            {
              name: {
                id: fleetId,
                name: fleetName,
              },
              time: entruckTime,
              estimateArriveTime,
              endPosition: deliveryFullId || [],
              endPort: {
                supplier_name: deliveryPortName || '',
                id: deliveryPortId || '',
              },
              num: fleetCount,
              table: carList ? list : [],
            },
          ],
        };
        this.dialogVisible = true;
        await this.searchCar();
      },
      // 完成 —— 打开弹窗
      finishClick(id) {
        this.$refs.carFinish.openDialog(id);
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._vehicleDeployFleetCvPageList();
      },
      // 重置
      resetBtn() {
        this.taskIpt = '';
        this.teamIpt = '';
        this.startPlace = '';
        this.endPlace = '';
        this.startPort = '';
        this.endPort = '';
        this.state = '';
        this.startTime = '';
        this.endTime = '';
      },
      resetBtnVehicle() {
        //重置委托车
        this.entrust = {
          batch: '', // 批次号
          waybill: '', // 运单号
          frame: '', // 车架号
          brandName: '',
          modelName: '',
          arrivePort: '',
          arrivePlaceId: '',
        };
      },
      // 分配运输车
      async distribution(id) {
        await this.$refs.carDriver.openDialog(id);
      },
      triggerQuery(arrivePlaceIdList) {
        this.searchCar();
      },
      // 新增按钮
      async addBtn() {
        this.dialogTitle = '新增';
        this.dialogVisible = true;
        this.activeName = '委托车';
        await this._getHighwayParam();
        this.addDriverTable = [];
        this.addCarTable = [];
        this.startTable = [];
        this.endTable = [];
        this.checkCar = [];
        this.selectDataAdd = [];
        this.positionOption = this.tempOption;
        this.positionOption2 = this.tempOption;
        this.carPage.total = 0;
        this.teamData = {
          position: '',
          startPort: '',
          radio: 0,
          team: [
            {
              name: '',
              num: 1,
              time: '',
              estimateArriveTime: '',
              endPosition: '',
              endPort: '',
              table: [],
            },
          ],
        };
      },
      // 新增/修改 —— 确认
      addClick() {
        this.$refs.ruleForm.validate(async valid => {
          let resource = this.resource;
          if (valid) {
            const start = this.$refs['startPosition'].getCheckedNodes();
            if (this.teamData.team.length === 0) {
              return this.$message.warning('请至少选择一个供应商！');
            } else {
              let temp = false;
              if (this.teamData.team.length > 0) {
                this.teamData.team.forEach(item => {
                  for (let teamKey in item) {
                    if (teamKey == 'table' || teamKey == 'endPort' || (teamKey == 'endPosition' && resource == '1')) continue;
                    if (!item[teamKey] || item[teamKey] == '') {
                      temp = true;
                    }
                  }
                });
              }
              if (temp) return this.$message.warning('选择供应商数据必填项数据不能为空！');
            }
            console.log(this.teamData.team);
            let arr = [];
            this.teamData.team.forEach((item, index) => {
              let end = null;
              if (resource === '0') {
                end = this.$refs['endPosition'][index].getCheckedNodes();
              }
              let list = [];
              if (item.table && item.table.length > 0) {
                item.table.forEach(tem => {
                  list.push({ carId: tem.id });
                });
              }
              arr.push({
                fleetId: item.name.id,
                fleetName: item.name.name,
                fleetCount: item.num,
                entruckTime: item.time,
                estimateArriveTime: item.estimateArriveTime,
                status: this.teamData.status,
                id: this.teamData.id,

                deliveryType: item.endPort.id ? 1 : 0,
                deliveryId: resource === '0' ? end[0].data.id : null,
                deliveryFullId: resource === '0' ? item.endPosition.join('/') : null,
                deliveryName: resource === '0' ? end[0].pathLabels.join('/') : null,
                deliveryCoordinate: resource === '0' ? end[0].data.center : null,
                deliveryPortId: item.endPort.id || '',
                deliveryPortName: item.endPort.supplier_name || '',
                carList: list,
              });
            });
            let startPortName = '';
            if (this.startPortList.length > 0) {
              this.startPortList.forEach(item => {
                if (item.id == this.teamData.startPort) {
                  startPortName = item.supplier_name;
                }
              });
            }
            this.loading = true;
            const obj = {
              startType: this.teamData.startPort ? 1 : 0,
              startId: start[0].data.id,
              startName: start[0].pathLabels.join('/'),
              startCoordinate: start[0].data.center,
              startFullId: this.teamData.position.join('/'),
              startPortId: this.teamData.startPort || '',
              startPortName: startPortName,
              resource: resource,
              deployFleetList: arr,
            };
            const res = this.dialogTitle === '新增' ? await vehicleDeployInfoCvAdd(obj) : await vehicleDeployInfoUpdate(obj);
            if (res.status !== 0) {
              this.loading = false;
              return this.$message.error(res.message);
            }
            this.$message.success(res.message);
            this.$refs.carTableRef.clearSelection();
            this.dialogVisible = false;
            this.loading = false;
            this.endPortList = [];
            await this._vehicleDeployFleetCvPageList();
          } else {
            return false;
          }
        });
      },
      // 新增/修改 —— 取消
      dialogClose() {
        this.$refs.carTableRef.clearSelection();
        this.$refs.ruleForm.resetFields();
        this.endPortList = [];
        this.entrust = {
          batch: '', // 批次号
          waybill: '', // 运单号
          frame: '', // 车架号
          brandName: '',
          modelName: '',
          arrivePort: '',
          arrivePlaceId: '',
        };
        this.resource = '0';
        this.dialogVisible = false;
      },
      // 修改交车地 -- 打开弹窗
      changeDelivery(row) {
        this.$refs.carDelivery.positionOption2 = this.tempOption;
        this.$refs.carDelivery.openDialog(row);
      },
      searchCopyFormat(value, flag) {
        console.log(value);
        // value.clipboardData.getData('Text').split('\n')
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        console.log(splitArr);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'entrust.frame':
            this.entrust.frame = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      btnClick(obj) {
        switch (obj.label) {
          case '分配运输车':
            this.distribution(obj.row.id);
            return;
          case '详情':
            this.detailClick(obj.row.id);
            return;
          case '修改':
            this.changeClick(obj.row.id);
            return;
          case '完成':
            this.finishClick(obj.row.id);
            return;
          case '删除':
            this.deleteClick(obj.row.id);
            return;
          case '修改交车地':
            this.changeDelivery(obj.row);
            return;
          case '修改供应商':
            // console.log('id: ', obj.row.id);
            // console.log('supplierId: ', obj.row.fleetId);
            this._getHighwayParam();
            this.supplierData.supplierId = obj.row.fleetId;
            this.activeId = obj.row.id;
            this.supplierVisible = true;
            return;
        }
      },
      scaleUpRestore() {},
      async expandColumn(row, expandedRows) {
        this.expandsLoad = true;
        const { status, message, data } = await endListDetails({
          arrivePortId: row.arrivePortId,
          arrivePlaceId: row.arrivePlaceId,
        });
        this.expandsLoad = false;
        if (status !== 0) return this.$message.warning(message);
        this.expandsData = data || [];
        // 每次只展开一行
        let that = this;
        if (expandedRows.length) {
          that.expands = [];
          if (row) {
            that.expands.push(row.soleId);
          }
        } else {
          that.expands = [];
        }
      },
    },
    watch: {
      selectAllHint(newVal) {
        if (newVal) {
          this.$message.warning('请选择供应商！');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;

        .tableContainerNav {
          text-align: right;
          color: rgba(51, 136, 255, 1);

          span {
            display: inline-block;
            font-size: 16px;
            text-decoration: underline;

            i {
              font-size: 16px;
              text-decoration: underline;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    ::v-deep.detail2 {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow-y: auto;

      .tableAddBtnContainer {
        border: 1px solid #ebeef5;
        border-top-style: none;
        width: 100%;
        //height: 35px;
        display: flex;
        align-items: center;
        //padding-left: 15px;
        ::v-deep {
          .el-select .el-input.is-focus .el-input__inner {
            border-color: #dcdfe6;
          }

          .el-select .el-input__inner:focus {
            border-color: #dcdfe6;
          }
        }

        .AddContainer {
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          object-fit: cover;
          margin-right: 5px;
        }

        p {
          font-size: 13px;
          color: #f59a23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }

        .addBtn {
          outline: none;
          width: 100%;
          color: #3d3d3d;
          background-color: #fff;
          border: 1px solid #cecece;
          font-size: 12px;
          height: 20px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .el-table td {
        padding: 5px 0;
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 0px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          .el-form-item__label {
            font-weight: 700;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        .el-form-item {
          margin-bottom: 0 !important;
        }

        ::v-deep {
          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }

      ::v-deep {
        .el-input--mini .el-input__inner {
          width: 100%;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-table td,
        .el-table th {
          padding: 0;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          &Item {
            margin-bottom: 10px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .company {
      height: 70vh;
      width: 100%;
      padding: 20px;
      overflow: auto;

      .team {
        margin: 20px 0 10px 0;

        &Add {
          display: flex;
          align-items: center;
          margin-left: 10px;
          margin-top: 10px;

          .add {
            width: 20px;
            height: 20px;
            padding-bottom: 3px;
            background-color: #999;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            margin-right: 15px;

            &:hover {
              cursor: pointer;
            }
          }

          span {
            font-size: 14px;
            color: #606266;
            font-weight: 700;
          }
        }

        &Item {
          display: flex;
          align-items: center;
          color: #999;
          font-size: 14px;
          margin-top: 10px;
          padding-bottom: 10px;

          span {
            margin-left: 5px;
            color: #606266;
            font-weight: 700;
          }

          border-bottom: 1px solid #cbcbcb;
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 12px;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .transport {
        width: 100%;
        border: 1px solid #c3c3c3;
        position: relative;
        padding: 0 10px;
        margin-bottom: 20px;

        .productTable {
          margin-top: 15px;

          ::v-deep {
            .el-input--mini .el-input__inner {
              width: 100%;
            }

            .cell {
              font-size: 10px;
              padding: 0;
            }

            .el-table td,
            .el-table th {
              padding: 0;
            }
          }

          .tableAddBtnContainer {
            border: 1px solid #ebeef5;
            border-top-style: none;
            width: 100%;
            //height: 35px;
            display: flex;
            align-items: center;
            //padding-left: 15px;
            ::v-deep {
              .el-select .el-input.is-focus .el-input__inner {
                border-color: #dcdfe6;
              }

              .el-select .el-input__inner:focus {
                border-color: #dcdfe6;
              }
            }

            .AddContainer {
              display: flex;
              align-items: center;

              &:hover {
                cursor: pointer;
              }
            }

            img {
              object-fit: cover;
              margin-right: 5px;
            }

            p {
              font-size: 13px;
              color: #f59a23;
              font-family: 'Arial Normal', 'Arial', sans-serif;
            }

            .addBtn {
              outline: none;
              width: 100%;
              color: #3d3d3d;
              background-color: #fff;
              border: 1px solid #cecece;
              font-size: 12px;
              height: 20px;

              &:hover {
                cursor: pointer;
              }
            }
          }

          .paginationContainer {
            margin-right: auto;
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            span {
              font-size: 13px;
            }
          }
        }

        &Title {
          margin-bottom: 0;
          position: absolute;
          top: -21px;
          z-index: 999;
          background-color: #fff;
          left: 20px;
          padding-right: 10px;
          color: rgb(51, 84, 131);
          font-size: 15px;
          font-weight: 700;

          ::v-deep {
            .el-form-item__label {
              color: rgb(51, 84, 131);
              font-size: 15px;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-table .cell.el-tooltip span:first-child {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      max-width: 150px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .transport {
      padding-top: 20px !important;
    }

    .el-button + .el-button {
      margin-left: 5px !important;
    }

    .el-button--mini,
    .el-button--mini.is-round {
      // padding: 7px 8px;
      margin-top: 2px;
    }
  }

  i.port-icon {
    position: absolute;
    display: inline-block;
    left: 120px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    text-align: center;
    line-height: 20px;
    background: red;
    color: #fff;
    border-radius: 50%;
  }

  .del-style {
    text-align: left;
    padding-left: 20px;
    height: 28px;
    line-height: 28px;

    ::v-deep {
      .el-radio {
        margin-right: 15px;

        .el-radio__label {
          display: none;
        }
      }

      i.el-icon-error {
        height: 28px;
        line-height: 28px;
        font-size: 16px;
      }
    }
  }

  .required:before {
    content: '* ';
    color: red;
  }

  .navContainer p {
    display: inline-block;
    width: 85px;
    text-align: right;
  }

  .position {
    color: #999;
    font-size: 12px;
    position: absolute;
    bottom: -25px;
    left: 0;
  }

  .finish {
    padding: 30px 50px;

    span {
      display: inline-block;
      width: 85px;
    }
  }
</style>
